<template>
  <div class="exchange_account_view">
    <h3>계좌정보</h3>
    <p class="description">본인 계좌번호만 신청이 가능합니다.</p>
    <dl>
      <dt>계좌주</dt>
      <dd>{{ exchangeInit.userName }}</dd>
    </dl>
    <dl>
      <dt>은행이름</dt>
      <dd>{{ exchangeInit.bankName }}</dd>
    </dl>
    <dl>
      <dt>계좌번호</dt>
      <dd class="form">
        <div class="result">{{ exchangeInit.accountNo }}</div>
      </dd>
    </dl>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VButton from '@/components/atoms/VButton';

export default {
  components: {
    VButton,
  },
  computed: {
    ...mapGetters('exchange', ['exchangeInit']),
  },
  methods: {
    ...mapActions('exchange', ['setExchangeAccountModify']),
    handleClick() {
      this.setExchangeAccountModify([this.exchangeInit.bankName, this.exchangeInit.accountNo]);
    },
  },
};
</script>
<style lang="scss"></style>
